import script from "./header.vue?vue&type=script&setup=true&name=header&lang=js"
export * from "./header.vue?vue&type=script&setup=true&name=header&lang=js"

import "./header.vue?vue&type=style&index=0&id=375abb92&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-375abb92"]])

export default __exports__